// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './axios/axios'
import store from './store/index'
import ElementUI from 'element-ui' //饿了么ui
//import vueTouch from 'kim-vue-touch'  //触摸事件
//import VueTouch from 'vue-touch'
import waterfall from 'vue-waterfall2' //瀑布流
import 'element-ui/lib/theme-chalk/index.css'
import '../static/font_icon/iconfont.css'
import '../static/font_icon/demo.css'
import '../static/font_icon/iconfont.js'
// import '../static/font_icon1/iconfont.css'
// import '../static/font_icon1/demo.css'
// import '../static/font_icon1/iconfont.js'
import SlideVerify from 'vue-monoplasty-slide-verify';
import VueTouchKeyboard from "vue-touch-keyboard";
import "vue-touch-keyboard/dist/vue-touch-keyboard.css";
import $jquery from 'jquery'
import html2canvas from 'html2canvas'
import { exec } from 'child_process'
if (!!window.ActiveXObject || "ActiveXObject" in window) {
    console.log('yes')
} else {
    console.log('yes')
        //var vueTouch=require ('kim-vue-touch')
    var vueTouch = () =>
        import ('kim-vue-touch')
    Vue.use(vueTouch)
}
//Vue.use(VueTouch)
Vue.use(VueTouchKeyboard);
Vue.prototype.$html2canvas = html2canvas
import { Field, Swipe, SwipeItem, Progress, PullRefresh, DatetimePicker, Picker, Loading, Uploader, Tab, Tabs, Cell, Icon, Toast } from 'vant';
//import vant from 'vant'
Vue.use(Field).use(Swipe).use(SwipeItem).use(Progress).use(PullRefresh).use(DatetimePicker).use(Picker).use(Loading).use(Tab).use(Tabs).use(Cell).use(Icon).use(Toast);
Vue.use(ElementUI);
Vue.use(SlideVerify);
//Vue.use(vant)

Vue.use(waterfall);
//Vue.use($jquery)
Vue.use(Uploader)
Vue.prototype.axios = axios;
Vue.prototype.store = store;

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

if (process.env.NODE_ENV === 'production') {
    //  Vue.prototype.url = 'https://api.seeonce.cn';
    Vue.prototype.url = 'https://dat.seeonce.cn'

} else {
    Vue.prototype.url = '/api';

}

Vue.config.productionTip = false
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})




// 适配
// 1rem = 16px
// iphone6  width = 375      16
//          height = 667

// 字体大小 = 667 / 375 * 16
// function calcSize() {
//   var width = document.documentElement.clientWidth;
//   var html = document.querySelector("html");
//   if (width <= 1024) {
//     // 设置html根标签的fontSize属性
//     html.style.fontSize = 9 + "px";
//   } else if (width > 1024 && width <= 1366) {
//     // 设置html根标签的fontSize属性
//     html.style.fontSize = 10 + "px";
//   } else if (width > 1366 && width < 1680) {
//     html.style.fontSize = 12 + "px";
//   } else {
//     html.style.fontSize = 14 + "px";
//   }
// }
function calcSize() {
    var width = document.documentElement.clientWidth;
    var html = document.querySelector("html");
    if (width <= 1280) {
        //设置html根标签的fontSize属性
        html.style.fontSize = 9.2 + "px";
    } else if (width <= 1152) {
        //设置html根标签的fontSize属性
        html.style.fontSize = 6 + "px";
    } else if (width <= 1440) {
        //设置html根标签的fontSize属性
        html.style.fontSize = 10.4 + "px";
    } else if (width <= 1366) {
        //设置html根标签的fontSize属性
        html.style.fontSize = 10 + "px";
    } else if (width <= 1600) {
        //设置html根标签的fontSize属性
        html.style.fontSize = 11.5 + "px";
    } else if (width < 1920) {
        //设置html根标签的fontSize属性
        html.style.fontSize = 12 + "px";
    } else {
        html.style.fontSize = 14 + "px";
    }
    if (width >= 2500) {
        html.style.fontSize = 18 + "px";
    }
}
calcSize();
// // 窗口重置大小时，调用函数修改根标签大小
window.onresize = function() {
    calcSize();
}


// WEBPACK FOOTER //
// ./src/main.js